"use strict";

$(".commercial__item").each(function (i, el) {
  let $tooltip = $(el).find(".commercial__label");
  $(el).find(".commercial__svg-hover").click(function (event) {
    event.preventDefault();
    let $link = $(event.currentTarget);

    if ($link.data("status") !== "sold") {
      let url = $link.data("url");
      window.location = url;
    }
  }).hover(function ()
  /*event*/
  {
    fillLabel($(this));
    $(this).addClass("commercial__svg-hover--active");
  }, function () {
    $(this).removeClass("commercial__svg-hover--active");
    $tooltip.removeClass("commercial__label--active");
  });

  function checkWindth() {
    let width = $(el).find("svg.commercial__svg").width();
    $(el).find("img.commercial__svg").css({
      width: `${width}px`
    });
  }

  checkWindth();
  $(window).resize(_.debounce(checkWindth, 100));

  function fillLabel(item) {
    let status = item.data("status");

    if (status === "sold") {
      $tooltip.html(`
  <div class="commercial__label-description">
    <p class="commercial__label--single-title-text">Квартира продана</p>
  </div>`).addClass("commercial__label--active");
    } else {
      let number = item.data("number");
      let area = item.data("area");
      let rooms = item.data("rooms");
      let price = item.data("price");
      $tooltip.html(`
  <div class="commercial__label-description">
    <p class="commercial__label-text commercial__label-text--number">Квартира №<span>${number}</span></p>
    <p class="commercial__label-text commercial__label-text--area"><span>${area}</span> м² </p>
    <p class="commercial__label-text commercial__label-text--rooms"><span>${rooms}</span> комн.</p>
    <p class="commercial__label-text commercial__label-text--price"><span>${price}</span> ₽</p>
  </div>`).addClass("commercial__label--active");
    }
  }

  $(el).find(".commercial__visual").mousemove(function (e) {
    window.requestAnimationFrame(() => {
      let pos = $(el).offset();
      let elem_left = pos.left;
      let elem_top = pos.top;
      let x = e.pageX - elem_left;
      let y = e.pageY - elem_top - 108;
      $tooltip.css({
        top: y + "px",
        left: x + "px"
      });
    });
  });
});
//# sourceMappingURL=commercial.js.map
